import React from 'react';

const LabelImage = (props) => {
  return (
    <div>
      <img
        src={props.image}
        className="nx-label-image img-fluid"
        alt={props.alt}
      />
      <div className="nx-lable-image-text-container">
        <span className="nx-label-image-text">{props.title}</span>
      </div>
    </div>
  );
};

export default LabelImage;
